import DataTransferObject from '@/Communication/DataTransferObject';
import ComponentManager from '@/Management/ComponentManager';

export default class MemberOfDTO extends DataTransferObject {

    public PDO_ID: number;

    public UserGroupPDO_ID: number;

    public Principals: Array<number>;

    constructor() {
        super({ xmlProperties: ['PDO_ID', 'UserGroupPDO_ID', 'Principals'], xmlNamespace: 'RADFoundation.RoleAssignment' });

        this.PDO_ID = this.defaultFromType('long');
        this.UserGroupPDO_ID = this.defaultFromType('long');
        this.Principals = this.defaultFromType('array');
    }
}

ComponentManager.setModel('MemberOfDTO', MemberOfDTO, 'RADPresentation.HTMLClient.DefaultViewExtensions');